export interface IFeatureFlagState {
	featureFlags: Record<string, boolean>;
}

export const defaultState = (): IFeatureFlagState => ({
	featureFlags: {}
});

export default defaultState;
